import styled from 'styled-components';

// Reserve room for a header, filters and two schedule rows even on the first visit.
// Real content can grow naturally; there is no fixed-height scrolling region.
export const FeaturedEventShell = styled.div`
    display: block;
    min-height: 320px;
    background-color: var(--wpa-surface);
    border: 1px solid rgba(255, 255, 255, 0.12);
    border-radius: 10px;
    padding: 16px;
    box-shadow: 0 10px 22px rgba(0, 0, 0, 0.2);
    @media (max-width: 600px) { min-height: 440px; }
`;

const Placeholders = styled.div`
    .placeholder-bar {
        border-radius: 6px;
        background: rgba(215, 227, 243, 0.12);
        margin-bottom: 12px;
    }
    .placeholder-row { height: 66px; }
    @media (max-width: 767px) { .placeholder-row { height: 124px; } }
`;

export function MatchPlaceholders({ filters = false }: { filters?: boolean }) {
    return <Placeholders aria-hidden="true" style={{ paddingTop: 10 }}>
        {filters && <div className="placeholder-bar" style={{ width: '65%', height: 38, marginLeft: 'auto' }} />}
        {[0, 1].map(index => <div key={index} className="placeholder-bar placeholder-row" />)}
    </Placeholders>;
}

export function FeaturedEventPlaceholder({ loading = true }: { loading?: boolean }) {
    return <FeaturedEventShell data-event-placeholder="true">
        {loading ? <>
            <span className="sr-only">Loading tournament…</span>
            <Placeholders aria-hidden="true">
                <div className="placeholder-bar" style={{ width: '80%', height: 54 }} />
                <div className="placeholder-bar" style={{ width: '40%', height: 38 }} />
            </Placeholders>
            <MatchPlaceholders filters />
        </> : <p>Tournament unavailable. Use Retry above to try again.</p>}
    </FeaturedEventShell>;
}
